import { render } from "./AddInput.vue?vue&type=template&id=f8294af4&scoped=true"
import script from "./AddInput.vue?vue&type=script&lang=js"
export * from "./AddInput.vue?vue&type=script&lang=js"

import "./AddInput.vue?vue&type=style&index=0&id=f8294af4&scoped=true&lang=scss"
script.render = render
script.__scopeId = "data-v-f8294af4"

export default script